//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDetail, fetchDelete } from '@/api/PMS/baseInformation/pakinglotoa';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      areaId: '',
      title: '',
      childData: {},
      dialogFormVisible: false,
      dialogBindingVisible: false
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      }
    },
    handleUpdate: function handleUpdate() {
      this.title = '编辑';
      this.$emit('handDetailCancle', 'pakinglotoaEdit');
    },
    handleDelete: function handleDelete() {
      var _this2 = this;

      this.$confirm('你确定是要删除该车位, 是否继续?', '提示').then(function () {
        fetchDelete([_this2.keyValue]).then(function (response) {
          _this2.$emit('handDetailCancle', true);

          _this2.Alert({
            alertType: 'delete'
          });
        });
      });
    },
    // 绑定业主
    changeProprietor: function changeProprietor() {
      this.title = '绑定业主';
      this.$emit('handDetailCancle', 'pakingCustomer');
    }
  }
};